// /app/frontend/src/components/frugal-v2/utils/alertHelpers.js
// Alert helper functions (40 lines)

export const getCategoryName = (category, t) => {
  const names = {
    'Alimentacion': t?.('frugal.reserves.food') || 'Alimentación',
    'Salud': t?.('frugal.reserves.health') || 'Salud',
    'Transporte/Mantenimiento': t?.('frugal.reserves.transport') || 'Transporte'
  };
  return names[category] || category;
};

export const isRedAlert = (type) => 
  ['exceeded', 'no_budget', 'contingency_starting_use', 'contingency_used', 'all_funds_depleted'].includes(type);

export const isVitalAlert = (type) => 
  ['vital_starting_use', 'vital_used'].includes(type);

export const getAlertMessage = (alert, t) => {
  const catName = getCategoryName(alert.category, t);
  switch(alert.type) {
    case 'vital_starting_use':
      return t?.('frugal.alerts.vitalStartingUse') || 'Se ha iniciado el uso de la Reserva Vital';
    case 'vital_used':
      return `${t?.('frugal.alerts.vitalUsed') || 'Consumo de Reserva Vital'}: $${alert.amount?.toFixed(2)}`;
    case 'contingency_starting_use':
      return t?.('frugal.alerts.contingencyStartingUse') || 'Reserva Vital agotada. Se inició el uso de Contingencia';
    case 'contingency_used':
      return `${t?.('frugal.alerts.contingencyUsed') || 'Consumo de Contingencia'}: $${alert.amount?.toFixed(2)}`;
    case 'all_funds_depleted':
      return t?.('frugal.alerts.allFundsDepleted') || 'Todos los fondos de reserva agotados';
    case 'warning':
      return t?.('frugal.alerts.vitalWarning', { category: catName, percent: alert.percent, days: alert.days_remaining });
    case 'exceeded':
      return t?.('frugal.alerts.vitalExceeded', { category: catName, excess: alert.excess?.toFixed(2) });
    case 'no_budget':
      return t?.('frugal.alerts.vitalNoBudget', { category: catName, spent: alert.spent?.toFixed(2) });
    default:
      return alert.message || '';
  }
};
